const graphicsData = {
  "bodies": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3
    }
  ],
  "bottoms": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0,
      "staff": true
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 11
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 13
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 14
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 15
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 16
    },
    {
      "designs": 4,
      "style": "masculine",
      "number": 17
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 18
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 19
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 20
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 21
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 22
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 23
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 24
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 25
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 26
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 27
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 28
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 29
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 30
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 31
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 32
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 33
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 34
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 35
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 36
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 37
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 38
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 39
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 40
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 41
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 42
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 43
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 44
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 45
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 46
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 47
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 48
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 49
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 50
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 51
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 52
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 53
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 54
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 55
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 56
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 57
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 58
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 59
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 60
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 61,
      "staff": true
    }
  ],
  "torsos": [
    {
      "designs": 2,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 6,
      "staff": true
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 11
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 13
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 14
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 15
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 16
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 17
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 18
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 19
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 20
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 21
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 22
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 23
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 24
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 25
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 26
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 27
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 28
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 29
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 30
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 31
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 32
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 33
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 34
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 35
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 36
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 37
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 38
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 39
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 40
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 41
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 42
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 43
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 44
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 45,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 46
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 47,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 48,
      "staff": true
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 49
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 50
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 51
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 52
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 53
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 54
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 55
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 56
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 57
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 58
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 59
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 60
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 61
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 62
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 63
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 64
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 65
    },
    {
      "designs": 4,
      "style": "feminine",
      "number": 66
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 67
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 68,
      "staff": true
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 69
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 70
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 71,
      "staff": true
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 72,
      "staff": true
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 73
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 74
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 75
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 76
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 77
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 78
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "hairs": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 5,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 6,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 7,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 11,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 13,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 14,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 15,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 16,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 17,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 18,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 19
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 20
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 21,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 22,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 23,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 24,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 25,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 26,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 27
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 28,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 29
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 30
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 31
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 32
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 33,
      "category": "short"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 34,
      "category": "short"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 35
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 36
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 37
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 38
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 39
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 40
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 41
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 42
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 43
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 44
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 45
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 46
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 47
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 48
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 49
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 50
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 51
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 52
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 53
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 54
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 55
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 56
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 57
    },
    {
      "designs": 3,
      "style": "feminine",
      "number": 58
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 59
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 60
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 61
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 62
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 63
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 64
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 65
    }
  ],
  "shoes": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 1,
      "staff": true
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 3,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 4,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 11,
      "staff": true
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 13
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 14
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 15
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 16,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 17
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 18,
      "staff": true
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 19
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 20
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "elbows": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "facial_hairs": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 11
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 13
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 14
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 15
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 16
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 17
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 18
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 19
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "accessories": [
    {
      "designs": 3,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 4,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 6,
      "category":  "mask"
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 7,
      "category":  "mask"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 11
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 13
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 14
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 15
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 16
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 17
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 18
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 19
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 20
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 21
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 22
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 23
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 24
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 25
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 26
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 27
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 28
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 29
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 30,
      "staff": true,
      "category": "glasses"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 31
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 32,
      "staff": true,
      "category": "glasses"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 33,
      "staff": true,
      "category": "glasses"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 34
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 35
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 36,
      "staff": true,
      "category": "suit"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 37,
      "staff": true,
      "category": "suit"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 38,
      "staff": true,
      "category": "suit"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 39
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 40
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 41
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 42
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 43
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 44
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 45
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 46
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 47
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 48
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 49
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 50
    },
    {
      "designs": 2,
      "style": "feminine",
      "number": 51
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 52
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 53
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": 54
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 55,
      "staff": true,
      "category": "doctor"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 56
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 57
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 58
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 59
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 60
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 61
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 62
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 63
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 64
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 65
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 66
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 67
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 68
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 69
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 70
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 71
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 72
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 73
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 74
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 75
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 76
    },
    {
      "designs": 4,
      "style": "masculine",
      "number": 77,
      "category": "mask"
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 78,
      "category":  "mask"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 79
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 80
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 81
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 82
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 83
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 84
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 85
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 86
    },
    {
      "designs": 4,
      "style": "masculine",
      "number": 87
    },
    {
      "designs": 4,
      "style": "masculine",
      "number": 88,
      "category":  "mask"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 89
    },
    {
      "designs": 1,
      "style": "feminine",
      "number": -1
    }
  ],
  "facepaints": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 3,
      "category":  "mask"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 4,
      "category":  "mask"
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 5,
      "category":  "mask"
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 9,
      "category":  "mask"
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "kneepads": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "tattoos": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 1
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 2
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 3
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 4
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 5
    },
    {
      "designs": 3,
      "style": "masculine",
      "number": 6
    },
    {
      "designs": 2,
      "style": "masculine",
      "number": 7
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 8
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 9
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 10
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 11
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 12
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 13
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": 14
    },
    {
      "designs": 1,
      "style": "masculine",
      "number": -1
    }
  ],
  "eyes": [
    {
      "designs": 1,
      "style": "masculine",
      "number": 0
    }
  ],
  "bloodObjects": [
    {
      "designs": 1,
      "number": 0,
      "type":"forehead"
    },
    {
      "designs": 1,
      "number": 1,
      "type": "forehead"
    },
    {
      "designs": 1,
      "number": 2,
      "type": "forehead"
    },
    {
      "designs": 1,
      "number": 3,
      "type": "left_eye"
    },
    {
      "designs": 1,
      "number": 4,
      "type": "right_eye"
    },
    {
      "designs": 1,
      "number": 5,
      "type": "forehead"
    },
    {
      "designs": 1,
      "number": 6,
      "type": "forehead_right"
    },
    {
      "designs": 1,
      "number": 7,
      "type": "forehead_left"
    },
    {
      "designs": 1,
      "number": 8,
      "type": "right_arm"
    },
    {
      "designs": 1,
      "number": 9,
      "type": "left_arm"
    },
    {
      "designs": 1,
      "number": 10,
      "type": "forehead"
    },
    {
      "designs": 1,
      "number": 11,
      "type": "forehead_full"
    },
    {
      "designs": 1,
      "number": 12,
      "type": "forehead_full"
    }
  ]
};

const championshipsGraphicsData = {
  "centerPlate": [
    {
      "designs": 1,
      "number": 0,
      "gemPart": 9,
      "strapPart": 9,
      "sidePlatesPart": 9
    },
    {
      "designs": 1,
      "number": 1,
      "gemPart": 0,
      "strapPart": 0,
      "sidePlatesPart": 0
    },
    {
      "designs": 1,
      "number": 2,
      "gemPart": 1,
      "strapPart": 1,
      "sidePlatesPart": 1
    },
    {
      "designs": 1,
      "number": 3,
      "gemPart": 2,
      "strapPart": 2,
      "sidePlatesPart": 2
    },
    {
      "designs": 1,
      "number": 4,
      "gemPart": 3,
      "strapPart": 3,
      "sidePlatesPart": 3
    },
    {
      "designs": 1,
      "number": 5,
      "gemPart": 4,
      "strapPart": 4,
      "sidePlatesPart": 4
    },
    {
      "designs": 1,
      "number": 6,
      "gemPart": 5,
      "strapPart": 5,
      "sidePlatesPart": 5
    },
    {
      "designs": 1,
      "number": 7,
      "gemPart": 6,
      "strapPart": 6,
      "sidePlatesPart": 6
    },
    {
      "designs": 1,
      "number": 8,
      "gemPart": 7,
      "strapPart": 7,
      "sidePlatesPart": 7
    },
    {
      "designs": 1,
      "number": 9,
      "gemPart": 8,
      "strapPart": 8,
      "sidePlatesPart": 8
    }
  ],
  "sidePlates": [
    {
      "designs": 1,
      "number": 0,
      "sideGemsPart": 0
    },
    {
      "designs": 1,
      "number": 1,
      "sideGemsPart": 1
    },
    {
      "designs": 1,
      "number": 2,
      "sideGemsPart": 2
    },
    {
      "designs": 1,
      "number": 3,
      "sideGemsPart": 3
    },
    {
      "designs": 1,
      "number": 4,
      "sideGemsPart": 4
    },
    {
      "designs": 1,
      "number": 5,
      "sideGemsPart": 5
    },
    {
      "designs": 1,
      "number": 6,
      "sideGemsPart": 6
    },
    {
      "designs": 1,
      "number": 7,
      "sideGemsPart": 7
    },
    {
      "designs": 1,
      "number": 8,
      "sideGemsPart": 8
    },
    {
      "designs": 1,
      "number": 9,
      "sideGemsPart": 9
    },
    {
      "designs": 1,
      "number": 10,
      "sideGemsPart": 10
    },
    {
      "designs": 1,
      "number": 11,
      "sideGemsPart": 11
    },
    {
      "designs": 1,
      "number": 12,
      "sideGemsPart": 12
    },
    {
      "designs": 1,
      "number": 13,
      "sideGemsPart": 13
    },
    {
      "designs": 1,
      "number": 14,
      "sideGemsPart": 15
    },
    {
      "designs": 1,
      "number": 15,
      "sideGemsPart": 14
    },
    {
      "designs": 1,
      "number": 16,
      "sideGemsPart": 16
    },
    {
      "designs": 1,
      "number": 17,
      "sideGemsPart": 17
    },
    {
      "designs": 1,
      "number": 18,
      "sideGemsPart": 18
    },
    {
      "designs": 1,
      "number": 19,
      "sideGemsPart": 19
    },
    {
      "designs": 1,
      "number": 20,
      "sideGemsPart": 20
    },
    {
      "designs": 1,
      "number": -1,
      "sideGemsPart": 21
    }
  ]
};


const bodyColorsList = ["0xFFE4CB", "0xF4D7BC", "0xFFD9B6", "0xFFD4AB", "0xF2D2A5", "0xDFB58D", "0xCAA684", "0x7A6353"];
const hairColorsList = ["0x502F0C", "0x733A00", "0x844B11", "0xA3672B", "0xC48647", "0xB04F1B", "0xFFFA84", "0x471E08",
  "0x999999", "0xeb8c4e", "0x090909", "0x3e3120", "0xDEBE99", "0x4C4C4C", "0xAA8866", "0x4F1A00",
  "0x9A3300", "0xE5E5E5", "0xC05D1C", "0xD5C427", "0xEBB25F"];
const pantsColorsList = [
  // Greys
  "0x333333", "0x111216", "0x898B8E", "0x595959", "0x4C4C4C",
  // Navys
  "0x222744", "0x434C61", "0x414975", "0x2C2C35",
  // Khakis
  "0x9B7B58", "0x735B41", "0xC1A07D",
  // Other
  "0x57573D", "0x3F2625", "0xEAE8DB", "0x9C9872"
];
const shirtsColorsList = [
  // Greys
  "0xE4E4E4", "0xF0EEEE", "0x989898", "0x2B2B2B", "0xD1D1D1", "0x5B5B5B",
  // Blues
  "0xC4CFE5", "0xD9E2F5", "0xA9C1F1", "0x8CB4E1", "0xC5CCDC", "0x2E4679",
  // Pink
  "0xF7CEF7", "0xEFBAC2", "0xEEBDC9", "0xE69B8F",
  // Other
  "0xFCE3C7", "0x575932", "0xA52A2F", "0x51955A", "0x87AE49", "0xA54F24", "0x8EC6AD", "0x774354", "0xFFFCCF"
];
const jacketsColorsList = [
  // Navys
  "0x1A2D61", "0x465A7B", "0x2E384C", "0x3A4A6E", "0x2B448C", "0x2F3353",
  // Greys
  "0x6F7887", "0x656C76", "0x969CA4", "0x646464", "0xC5CCDC", "0x2E4679",
  // Browns
  "0x8C6953", "0x6A5738", "0x9D6236", "0x573923",
  // Khakis
  "0xCBBA9E", "0xC1A691", "0xC7C296", "0xEADAD4",
  // Olives
  "0x5B725E", "0x545743"
];
const glassesColorsList = ["0x333333", "0x7C6C5E", "0x434343", "0x171717"];
const shoesColorsList = ["0x1E1E1E", "0x3B3B3B", "0x553828"];
const doctorCoatColorsList = ['0xF3F3F3', '0xEEEEEE', '0xF1F5F9', '0xF8F9F9'];

export {graphicsData, championshipsGraphicsData, shirtsColorsList, hairColorsList, pantsColorsList, shoesColorsList,
  jacketsColorsList, glassesColorsList, bodyColorsList, doctorCoatColorsList}